import { Controller } from "@hotwired/stimulus"

// Follow-up questions that only apply to some talent categories stay hidden
// until the category that makes them relevant is checked.
export default class extends Controller {
  static targets = ["category", "nicheFields", "aiFields"]
  static values = { nicheCategories: Array, aiCategory: String }

  connect() {
    this.toggle()
  }

  toggle() {
    const selected = this.categoryTargets
      .filter((category) => category.checked)
      .map((category) => category.value)

    const needsNiche = selected.some((value) => this.nicheCategoriesValue.includes(value))
    const isAiTalent = selected.includes(this.aiCategoryValue)

    this.reveal(this.nicheFieldsTarget, needsNiche)
    this.reveal(this.aiFieldsTarget, isAiTalent)
  }

  // Hiding alone is not enough — hidden inputs still serialize, which would
  // save answers for a category the profile no longer claims.
  reveal(fields, visible) {
    fields.classList.toggle("hidden", !visible)
    fields.querySelectorAll("input, select").forEach((field) => {
      field.disabled = !visible
    })
  }
}
